// iOS风格主题配置

export const theme = {
  colors: {
    // iOS系统颜色
    primary: '#007AFF',
    secondary: '#5856D6',
    success: '#34C759',
    warning: '#FF9500',
    error: '#FF3B30',
    
    // 背景色
    background: {
      primary: '#FFFFFF',
      secondary: '#F2F2F7',
      tertiary: '#FFFFFF',
    },
    
    // 文本色
    text: {
      primary: '#000000',
      secondary: '#3C3C43',
      tertiary: '#3C3C4399',
      quaternary: '#3C3C4366',
    },
    
    // 分隔线
    separator: {
      opaque: '#C6C6C8',
      nonOpaque: '#3C3C4349',
    },
    
    // 填充色
    fill: {
      primary: '#78788033',
      secondary: '#78788028',
      tertiary: '#7676801E',
      quaternary: '#74748014',
    },
  },
  
  // 暗色模式
  darkColors: {
    primary: '#0A84FF',
    secondary: '#5E5CE6',
    success: '#30D158',
    warning: '#FF9F0A',
    error: '#FF453A',
    
    background: {
      primary: '#000000',
      secondary: '#1C1C1E',
      tertiary: '#2C2C2E',
    },
    
    text: {
      primary: '#FFFFFF',
      secondary: '#EBEBF5',
      tertiary: '#EBEBF599',
      quaternary: '#EBEBF566',
    },
    
    separator: {
      opaque: '#38383A',
      nonOpaque: '#54545899',
    },
    
    fill: {
      primary: '#7878805C',
      secondary: '#78788052',
      tertiary: '#7676803D',
      quaternary: '#74748033',
    },
  },
  
  // 字体
  fonts: {
    system: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    mono: 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace',
  },
  
  // 字体大小 (iOS Human Interface Guidelines)
  fontSizes: {
    largeTitle: '34px',
    title1: '28px',
    title2: '22px',
    title3: '20px',
    headline: '17px',
    body: '17px',
    callout: '16px',
    subhead: '15px',
    footnote: '13px',
    caption1: '12px',
    caption2: '11px',
  },
  
  // 字重
  fontWeights: {
    ultraLight: 100,
    thin: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    heavy: 800,
    black: 900,
  },
  
  // 间距 (基于8px网格)
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  
  // 圆角 (iOS风格)
  borderRadius: {
    none: '0',
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },
  
  // 阴影 (简洁风格 - 无阴影)
  shadows: {
    sm: 'none',
    md: 'none',
    lg: 'none',
    xl: 'none',
    cardHover: 'none',
    cardPressed: 'none',
  },
  
  // 暗色模式阴影
  darkShadows: {
    sm: 'none',
    md: 'none',
    lg: 'none',
    xl: 'none',
    cardHover: 'none',
    cardPressed: 'none',
  },
  
  // 动画时长 (iOS标准)
  transitions: {
    fast: '0.15s',
    normal: '0.3s',
    slow: '0.5s',
  },
  
  // 缓动函数 (iOS标准)
  easings: {
    easeInOut: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0.0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
  },
  
  // 断点 (响应式设计)
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
  
  // Z-index层级
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
};

export type Theme = typeof theme;